import { AlertTriangle } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const eur = (v) => `€${Number(v || 0).toLocaleString('it-IT')}`;

export const CanoneMismatchDialog = ({ data, onCancel, onConfirm }) => (
  <AlertDialog open={!!data} onOpenChange={(o) => { if (!o) onCancel(); }}>
    <AlertDialogContent data-testid="canone-mismatch-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2 text-amber-700">
          <AlertTriangle className="h-5 w-5" /> Differenza di canone rilevata
        </AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="space-y-3 text-sm text-slate-600">
            <p>Il canone calcolato dal server non coincide con quello mostrato a schermo.</p>
            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-md border p-3">
                <p className="text-xs text-slate-500">A schermo</p>
                <p className="text-lg font-semibold text-slate-800" data-testid="canone-mismatch-atteso">{eur(data?.atteso)}/mese</p>
              </div>
              <div className="rounded-md border border-amber-300 bg-amber-50 p-3">
                <p className="text-xs text-amber-700">Verrà salvato e stampato</p>
                <p className="text-lg font-semibold text-amber-800" data-testid="canone-mismatch-server">{eur(data?.server)}/mese</p>
              </div>
            </div>
            <p>Se procedi, l'offerta e il PDF riporteranno il canone del server. Annulla per ricontrollare i parametri.</p>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="canone-mismatch-cancel">Annulla</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} data-testid="canone-mismatch-confirm">
          Salva con {eur(data?.server)}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
